"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createTheme: true,
  makeStyles: true,
  useTheme: true,
  ThemeProvider: true
};
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _Provider.ThemeProvider;
  }
});
exports["default"] = exports.createTheme = void 0;
exports.makeStyles = makeStyles;
exports.useTheme = void 0;
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _default2 = require("./themes/default");
var _Provider = require("./Provider");
var _theme = require("./theme.interfaces");
Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _theme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _theme[key];
    }
  });
});
var createTheme = function createTheme(newTheme) {
  if (newTheme) {
    return (0, _styles.createMuiTheme)((0, _lodash.merge)((0, _lodash.cloneDeep)(_default2.theme), newTheme));
  }
  return (0, _styles.createMuiTheme)(_default2.theme);
};
exports.createTheme = createTheme;
function makeStyles(style, options) {
  return (0, _styles.makeStyles)(style, options);
}
var useTheme = function useTheme() {
  return (0, _styles.useTheme)();
};
exports.useTheme = useTheme;
var _default = createTheme();
exports["default"] = _default;